let translationsALIST = {
	'underground4': '-4. szint',
	'underground3': '-3. szint',
	'underground2': '-2. szint',
	'underground1': '-1. szint',
	'basement': 'alagsor',
	'suteren': 'szuterén',
	'halfSuteren': 'félszuterén',
	'downstairs': 'földszint',
	'highDownstairs': 'magasföldszint',
	'halfUpstairs': 'félemelet',
	'20+': '20+',
	'10+': '10+',
	'order': 'Rendezés',
	'dateDesc': 'Dátum szerint legfrissebb',
	'dateAsc': 'Dátum szerint legrégebbi',
	'priceDesc': 'Ár szerint legdrágább',
	'priceAsc': 'Ár szerint legolcsóbb',
	'orderPlaceholder': 'Válasszon rendezési módot',
	'hitsText': 'talált ingatlan'
};
// emeletek
for (let i = 1; i <= 20; ++i) {
	translationsALIST[i] = i + '. emelet';
}

export default translationsALIST;
